import { Form, useFormikContext, useField } from 'formik';
import React, { useEffect, useCallback, FC } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { PhoneField } from 'src/libs/ui-kit/inputs/Phone';
import { StringField } from 'src/libs/ui-kit/inputs/String';
import { ContactType } from '../../constants';
import { CONTACT_TYPE } from '../../service-provider/interface';

export const CreateUserContactForm: FC = () => {
  const { resetForm, setFieldValue } = useFormikContext();
  useEffect(() => resetForm(), [resetForm]);

  const [type] = useField<ContactType>('type');

  // type приходится конвертировать в число, т.к. енам численный
  // ниже в качестве value так же передается строка, т.к. компонент принимает только строковое значение
  const onTypeChange = useCallback((type: ContactType) => setFieldValue('type', +type), [setFieldValue]);

  return (
    <Form>
      <div className="mt-2">
        <ToggleButtonGroup
          type="radio"
          name="type"
          value={type.value.toString()}
          onChange={onTypeChange}
          className="mb-4 w-100">
          <ToggleButton value={CONTACT_TYPE.MOBILE.toString()} variant="default">
            Телефон
          </ToggleButton>

          <ToggleButton value={CONTACT_TYPE.EMAIL.toString()} variant="default">
            E-mail
          </ToggleButton>
        </ToggleButtonGroup>
        {type.value === CONTACT_TYPE.MOBILE ? (
          <PhoneField name="phoneValue" label="Номер телефона" placeholder="Введите номер телефона" />
        ) : (
          <StringField name="emailValue" label="Почта" placeholder="Введите e-mail" />
        )}
      </div>
    </Form>
  );
};
